import React, { Component } from 'react';
class MissionVision extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  componentDidMount() {

  }


  render() {
    return (
      <div className="container-xxl mt-5 inner_con_grey" id="mission">
          <div className="container inner_con">
          <div className="row g-4">
            <h1 className="text-start mt-5 mb-3 wow fadeInUp title_view" data-wow-delay="0.1s">Mission</h1>
            <div className="col-lg-12 wow fadeIn margin_top_zero" data-wow-delay="0.5s">
            <p className="mb-2">To provide precise, reliable and grounded legal solutions that support compliance, governance and dispute resolution in an increasingly complex legal and regulatory environment.</p>
            </div>
            <h1 className="text-start mt-5 mb-3 wow fadeInUp title_view" data-wow-delay="0.1s">Vision</h1>
            <div className="col-lg-12 wow fadeIn margin_top_zero" data-wow-delay="0.5s">
            <p className="mb-5">To be recognised as a trusted legal institution known for regulatory insight, disciplined advocacy and principled legal practice serving clients with consistency, credibility and professional excellence.</p>
            </div>
            </div>
          </div>
      </div>
    );
  }
}

export default MissionVision;
